import { useState } from 'react';
import { updateLogoSelect } from '../../js/webGL';

export function useLogoFuncs(logos) {
  const [activeIdx, setActiveIdx] = useState(-1);

  const setCurrentLogo = (logo, ratio) => {
    for (let i = 0; i < window.decals.length; i += 1) {
      if (logo.Id !== window.decals[i].logo.Id) continue;
      window.currentLogo = window.decals[i].logo;
      window.currentLogo.Rotate = 0;
      window.currentLogo.ratio = ratio;
      return true;
    }
    return false;
  };

  const handleOnClick = (index, ratio) => {
    setActiveIdx(index);
    window.isSelectedLogoTool = index !== -1;
    var logo = logos[index];
    if (setCurrentLogo(logo, ratio)) {
      updateLogoSelect(window.currentLogo);
      return;
    }
    logo.Rotate = 0;
    logo.ratio = ratio;
    updateLogoSelect(logo);
  };

  return { activeIdx, handleOnClick };
}
